import { useEffect, useRef } from "react";
import { buildBankIdUrl, openBankId } from "../../utils/bankIdRedirect";

/** Opens BankID on this device once per order. A restart issues a new token. */
export const useBankIdAutoOpen = ({
  autoStartToken,
  enabled,
}: {
  autoStartToken?: string;
  enabled: boolean;
}) => {
  const openedToken = useRef<string>();

  useEffect(() => {
    if (!enabled || !autoStartToken || openedToken.current === autoStartToken) {
      return;
    }
    openedToken.current = autoStartToken;
    // Built here, not during render: a cancelled order's token links to nothing.
    // No nonce, because inApp suppresses the return redirect.
    const url = buildBankIdUrl({ autoStartToken, inApp: true });
    if (url) openBankId(url);
  }, [enabled, autoStartToken]);
};
